import { Fragment, useState } from "react";

import mainStore from "store/mainStore";
import ModelProduct from "./ModelProduct";
import QuickTable from "components/Meta/QuickTable";
import BoardHeader from "components/Meta/BoardHeader";

function WizardAddProduct(props) {
  let selectedRows = new Map();
  const ctxView = ModelProduct.ctxView();
  const { store, record, updateRecord, updateStore } = mainStore();
  const [domain, setDomain] = useState([["id", "=", -1]]);

  function onDoubleClickRow() {
    return;
  }

  function onClickRow(records) {
    if (records === null) {
      selectedRows = new Map();
    } else if (records instanceof Map) {
      selectedRows = new Map(records);
    } else {
      if (selectedRows.get(records.id)) {
        selectedRows.delete(records.id);
      } else {
        selectedRows.set(records.id, records);
      }
    }
  }

  function handleAccept() {
    const _storeRecord = { ...store };
    if (!_storeRecord.lines) {
      _storeRecord.lines = new Map();
      _storeRecord.lines.set("create", new Map());
    }
    const to_create = _storeRecord.lines.get("create");

    const activeRecord_ = { ...record };
    if (!activeRecord_.lines) {
      activeRecord_.lines = new Map();
    }

    const prods = Array.from(activeRecord_.lines.values()).map(
      (ItemRow) => ItemRow.product.id,
    );

    const time_ = new Date();
    let sq = -time_.getTime();
    for (let v of selectedRows.values()) {
      if (!prods.includes(v.id)) {
        const rec = {
          id: sq,
          product: {
            id: v.id,
            name: v.name,
            code: v.code,
            description: v.description,
          },
        };
        activeRecord_.lines.set(sq, rec);
        to_create.set(sq, { id: sq, product: v.id });
        sq += -1;
      }
    }
    updateRecord(activeRecord_);
    updateStore(_storeRecord);
    props.onClose();
  }

  return (
    <Fragment>
      <BoardHeader
        ctxView={ctxView}
        viewType={"list"}
        handleFilter={setDomain}
      />
      <QuickTable
        model={ctxView.model}
        ctxView={ctxView}
        selectable={ctxView.selectable}
        onDoubleClickRow={onDoubleClickRow}
        onClickRow={onClickRow}
        domain={domain}
        level="wizard"
      />
    </Fragment>
  );
}

export default WizardAddProduct;
